import { Component, Input } from '@angular/core';
// import { adBanner } from '../../../_configuration/configuration';

@Component({
  selector: 'app-partners',
  templateUrl: './partners.component.html',
  styleUrls: ['./partners.component.scss']
})
export class PartnersComponent {
  constructor() {}

  @Input() partnersUrl = '../../assets/img/etc/banner.png'; // +adBanner;
  @Input() partnerLink = '';
}
